'use client'

import { Cell } from '@vinted/web-ui'
import { useCallback, useEffect } from 'react'
import { useIntl } from 'react-intl'

import { useFetch } from '@marketplace-web/core-api/api-client-util'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { ContentLoader } from '@marketplace-web/common-components/content-loader-ui'
import { ErrorState } from '@marketplace-web/error-display/error-display-feature'
import {
  getRefund,
  transformRefundResponse,
} from '@marketplace-web/order-details/order-details-data'

import PaymentDetails from './PaymentDetails'

type Props = {
  transactionId: number
}

const RefundDetails = ({ transactionId }: Props) => {
  const translate = useTranslate('refund')
  const { locale } = useIntl()

  const labels = {
    amount: translate('refund_amount'),
    progress: translate('refund_progress'),
  }

  const {
    fetch: fetchRefund,
    transformedData: refund,
    isLoading,
    error,
  } = useFetch(getRefund, transformRefundResponse)

  const getRefundDetails = useCallback(() => {
    if (!transactionId) return

    fetchRefund(transactionId)
  }, [fetchRefund, transactionId])

  useEffect(() => {
    getRefundDetails()
  }, [getRefundDetails])

  if (isLoading)
    return <ContentLoader size={ContentLoader.Size.Large} testId="refund-details-loader" />

  if (error)
    return (
      <Cell>
        <ErrorState onCtaClick={getRefundDetails} />
      </Cell>
    )

  if (!refund?.progressDetails.length) return null

  return <PaymentDetails refund={refund} locale={locale} labels={labels} />
}

export default RefundDetails
